import styled from "styled-components";
import { Theme } from "theme";

export const StatTableWrapper = styled.div`
  overflow: auto;
`;

export const StatTableTable = styled.table`
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  text-align: center;
`;

const StatTableTr = styled.tr<{ thinner: boolean }>`
  cursor: default;

  td {
    padding: 4px 3px;
    white-space: nowrap;

    ${({ thinner }) => thinner && "padding: 1px 3px;"}
    @media (max-width: 700px) {
      padding: 2px;
      ${({ thinner }) => thinner && "padding: 1px 2px;"}
    }
  }

  th {
    padding: 4px 3px;
    white-space: nowrap;
    border-right: ${Theme.panelContentBorder};

    @media (max-width: 700px) {
      padding: 4px 2px;
    }

    &:last-child {
      border-right: 0;
    }
  }
`;

export const StatTableHeaderTr = styled(StatTableTr)``;

export const StatTableDataTr = styled(StatTableTr)<{
  clickable: boolean;
  hoverColor?: string;
}>`
  ${({ clickable, hoverColor }) =>
    clickable &&
    `cursor: pointer;
     &:hover {
       td { background: ${hoverColor ?? Theme.tabHoverBackground}; }
     }`}
`;

export const StatTableTh = styled.th<{
  clickable?: boolean;
  highlight?: boolean;
  highlightSort?: boolean;
  primaryColor?: string;
  secondaryColor?: string;
  frozenWidth?: number;
  frozenOffset?: number;
}>`
  border: ${Theme.panelContentBorder};
  border-width: 0 0 1px 0;
  background: ${Theme.tabBackground};

  @media (max-width: 700px) {
    font-size: 10.5pt;
  }

  ${({ clickable, secondaryColor }) =>
    clickable &&
    `cursor: pointer;  &:hover {
    background: ${secondaryColor ?? Theme.tabHoverBackground};
  }`}

  ${({ highlight }) =>
    highlight && `background: ${Theme.thHighlightBackground};`}
    
  ${({ highlightSort, primaryColor, secondaryColor }) =>
    highlightSort &&
    `background: ${secondaryColor ?? Theme.tabSelectedBackground};
    color: ${primaryColor ?? Theme.tabSelectedForeground};
  `}

  ${({ frozenWidth, frozenOffset }) =>
    !!frozenWidth &&
    frozenOffset !== undefined &&
    `@media (min-width: 700px) {position: sticky; 
     width: ${frozenWidth}px;
     max-width: ${frozenWidth}px;
     min-width: ${frozenWidth}px;
     box-sizing: border-box;
     left: ${frozenOffset}px;}`}
`;

export const StatTableTd = styled.td<{
  highlight?: boolean;
  frozenWidth?: number;
  frozenOffset?: number;
  border?: number;
}>`
  border: ${Theme.panelContentBorder};
  border-width: 0 0 1px 0;
  background: white;

  ${({ highlight }) =>
    highlight &&
    `background: ${Theme.tdHighlightBackground}; color: ${Theme.tdHighlightForeground}; font-weight: 500;`}

  ${({ frozenWidth, frozenOffset }) =>
    !!frozenWidth &&
    frozenOffset !== undefined &&
    `@media (min-width: 700px) {position: sticky; 
     width: ${frozenWidth}px;
     max-width: ${frozenWidth}px;
     min-width: ${frozenWidth}px;
     box-sizing: border-box;
     left: ${frozenOffset}px;}`}
     
  ${({ border }) => !!border && `border-right: ${border}px solid darkgray;`}
  ${({ border }) =>
    !!border &&
    `  box-shadow: 5px 0 15px 0px white;
       clip-path: inset(0px -15px 0px 0px);`}
`;

export const SortArrowContainer = styled.div`
  width: 10px;
  padding: 2px 4px 0 4px;
  font-size: 7pt;

  @media (max-width: 700px) {
    font-size: 6pt;
    width: 8px;
  }
`;

export const PaginationContainer = styled.div`
  padding: 4px 0;
`;

export const LegendContainer = styled.div`
  padding: 10px 0;
`;

export const FilterInputContainer = styled.div`
  padding: 10px 3px;
  margin-left: 10px;
  input {
    margin: auto;
    font-size: 11.5pt;
    width: 300px;
    padding: 4px;
  }
`;
